<template>
    <main class="col-md-9 ms-sm-auto col-lg-10 px-md-4">
        <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
            <div class="h4">比赛经历</div>
            <div class="btn-toolbar mb-2 mb-md-0">
            <div class="btn-group me-2">
                <button type="button" class="btn btn-sm btn-outline-secondary">Share</button>
                <button type="button" class="btn btn-sm btn-outline-secondary">Export</button>
            </div>
            <button type="button" class="btn btn-sm btn-outline-secondary dropdown-toggle">
                <span data-feather="calendar" class="align-text-bottom"></span>
                This week
            </button>
            </div>
        </div>
        <!-- 1111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111 -->
        <div>
            当前参加了 {{ count }} 场比赛
        </div>
        <!-- 1111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111 -->
        <div class="echart1">
        </div>

    </main>
</template>

<script>
    import Url from '@/constant/Url'
    import $ from 'jquery'
    export default {
        name:"CompeteExpence",
        data() {
            return {
                dataX:[],
                dataY:[],
                len:0,
                count:0,
            }
        },
        mounted() {
            if (this.$store.state.me.id !== "") this.readRating()
            else {
                const t = setInterval(() => {
                    if (this.$store.state.me.id !== "") {
                        this.readRating()
                        clearInterval(t); // 清除定时器
                    }
                }, 100);
            }
        },
        methods: {
            creatEchart(){
                let myChart=this.$echarts.init(document.querySelector('.echart1'))
                myChart.setOption({
                    xAxis: {
                        type: 'category',
                        data: this.dataY,
                        axisLabel: {
                            interval: this.len, // 设置显示间隔为2，显示五个点（间隔数 + 1）
                        },
                    },
                    yAxis: {
                        type: 'value'
                    },
                    tooltip: {
                        trigger: 'axis', // 设置 tooltip 触发方式为坐标轴触发
                        formatter: function (params) {
                            return params[0].name + ': ' + params[0].value; // 定制 tooltip 显示内容
                        },
                    },
                    series: [{
                        data: this.dataX,
                        type: 'line',
                        showBackground: true,
                        backgroundStyle: {
                            color: 'rgba(220, 220, 220, 0.8)'
                        }
                    }]
                })
                window.addEventListener('resize',function(){
                    myChart.resize()
                })
            },
            readRating() {
                const vue = this
                const store = this.$store
                $.ajax({
                    url: 'https://app6132.acapp.acwing.com.cn/jdg/settings/rankchart/',
                    type: 'post',
                    data: { 
                        uid: store.state.me.id,
                    },
                    success(resp) {
                        console.log(resp.rates)
                        vue.dataY.push("2023-12-26 20:24:00")
                        vue.dataX.push("1000")
                        vue.len = 0
                        if (resp.rates === undefined) {
                            vue.creatEchart()
                            return
                        }
                        for (let i = 0; i < resp.rates.length; i ++ ) {
                            vue.dataY.push(resp.rates[i].time)
                            vue.dataX.push(resp.rates[i].rate)
                        }
                        vue.len = parseInt(resp.rates.length / 5);
                        vue.count = resp.rates.length
                        vue.creatEchart()
                    }
                })
            }
        }
    }
</script>

<style scoped>
.echart1{
    width: 1180px;
    height: 500px;
    margin: 0 auto;

}
</style>